import React from "react";
import styled from "styled-components";
import CaretIcon from "sweet-web/components/icons/CaretIcon";
import { colors } from "sweet-web/lib/styles";

const StyledButton = styled.button`
  padding: 2px 10px;
  background-color: ${colors.white};
  color: ${colors.gray};
  border: 1px solid ${colors.lightGray};
  font-size: 14px;
  font-weight: 600;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border-radius: 5px;
  outline: none;
  &:hover {
    transform: scale(1.03);
    border-color: ${colors.gray};
    box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  }
  position: fixed;
  left: 45px;
  bottom: 45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

type Props = {
  onClick?: () => void;
  style?: object;
};
const BackButton: React.FC<Props> = props => {
  return (
    <StyledButton style={props.style} onClick={props.onClick}>
      <CaretIcon
        size={17}
        color={colors.gray}
        style={{
          transform: "rotate(-180deg)",
          marginRight: 10,
          marginBottom: 6
        }}
      />
      Back
    </StyledButton>
  );
};
BackButton.defaultProps = {
  style: {}
};

export default BackButton;
